<div *ngIf="open" class="viewer-container">
    <div class="viewer-content" (window:resize)="onResize()">
        <div class='imgdescr' *ngIf="!editDescr" (click)="startDescrEdit()">{{imgs[idx].txt}}</div>
        <input #descrInput matInput class='descrEdit' [(ngModel)]="imgs[idx].txt" *ngIf="editDescr" (focusout)="endDescrEdit()">
        <button mat-button class="imgvw-button close-button" (click)="close.emit()">
            <img src='/assets/close.png'>
        </button>
        <button mat-button class="imgvw-button left-button" (click)="idx=idx-1" *ngIf="idx>0">
            <img src='/assets/back.png'>
        </button>
        <button mat-button class="imgvw-button right-button" (click)="idx=idx+1" *ngIf="idx<imgs.length-1">
            <img src='/assets/forward.png'>
        </button>
        <ion-slides [options]="sliderOpts" zoom>
            <ion-slide>
                <div class="swiper-zoom-container">
                    <img class="fullscreen" [src]="imgs[idx].path ? globals.baseurl + 'doc.php?src=' + imgs[idx].path : imgs[idx].url">
                </div>
            </ion-slide>
        </ion-slides>
    </div>
</div>
